import { useContext, useEffect, useMemo, useRef } from "react";

import BlogCard from "../../components/marketing/BlogCard";
import Footer from "../../components/marketing/engineering/Footer";
import Reveal from "../../components/marketing/Reveal";
import Seo from "../../components/seo/Seo";
import Eyebrow from "../../components/marketing/Eyebrow";
import { blogPosts } from "../../content/blogPosts";
import { siteMetadata } from "../../content/siteMetadata";
import { ApplicationContext } from "../../context/GlobalState";
import { setPageMetadata } from "../../context/actions";
import MarketingLayout from "../../layouts/MarketingLayout";
import { sortBlogPosts } from "../../utils/siteUtils";

/**
 * Blog index route.
 * Translation: Blog index route.
 *
 * @returns {JSX.Element} Blog listing page.
 */
const Blog = () => {
  const heroRef = useRef(null);
  const [, dispatch] = useContext(ApplicationContext);

  const orderedPosts = useMemo(() => sortBlogPosts(blogPosts), []);

  useEffect(() => {
    dispatch(
      setPageMetadata({
        title: "Healthcare Data Engineering & AI Insights | Data Chimp Labs Blog",
        description:
          "Latest from Data Chimp Labs across healthcare data engineering, " +
          "clinical AI systems, and modern infrastructure.",
        image: siteMetadata.socialImage,
        pathname: "/blog",
      })
    );
  }, [dispatch]);

  return (
    <>
      <Seo
        title="Healthcare Data Engineering & AI Insights | Data Chimp Labs Blog"
        description="Latest from Data Chimp Labs across healthcare data engineering, clinical AI systems, and modern infrastructure."
        pathname="/blog"
        image={siteMetadata.socialImage}
      />

      <MarketingLayout heroRef={heroRef} footer={<Footer />}>
        <section ref={heroRef} className="blog-index">
          <div className="section-shell">
            <Reveal>
              <div className="section-heading">
                <Eyebrow>Insights</Eyebrow>
                <h1>Latest from Data Chimp Labs</h1>
              </div>
            </Reveal>

            <div className="card-grid card-grid--three">
              {orderedPosts.map((post, index) => (
                <Reveal key={post.slug} delay={index * 100}>
                  <BlogCard post={post} readLabel="Read More" />
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </MarketingLayout>
    </>
  );
};

export default Blog;
